import { render, staticRenderFns } from "./GtmEvents.vue?vue&type=template&id=54fddae9&"
import script from "./GtmEvents.vue?vue&type=script&lang=js&"
export * from "./GtmEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports